import { createSlice } from "@reduxjs/toolkit";

export const organizationSlice = createSlice({
  name: "organization",
  initialState: {
    organizations: [],
    activeOrganizationId: null,
    role: null,
  },
  reducers: {
    setOrganizations: (state, action) => {
      state.organizations = action.payload || [];
    },
    setActiveOrganization: (state, action) => {
      state.activeOrganizationId = action.payload?.id || null;
      state.role = action.payload?.role || null;
    },
    updateOrganizationInList: (state, action) => {
      const { id, changes } = action.payload || {};
      state.organizations = state.organizations.map((org) =>
        String(org.id) === String(id) ? { ...org, ...changes } : org,
      );
    },
    hydrateFromStorage: (state) => {
      const user = localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : {};
      const organizations = localStorage.getItem("organizations")
        ? JSON.parse(localStorage.getItem("organizations"))
        : [];
      state.organizations = organizations.map((org) => ({
        ...org,
        id:
          typeof org.id === "string"
            ? org.id
            : org.id?.$oid || String(org.id || ""),
      }));
      const activeId =
        user.activeOrganizationId?.$oid ||
        (typeof user.activeOrganizationId === "string"
          ? user.activeOrganizationId
          : String(user.activeOrganizationId || ""));
      state.activeOrganizationId = activeId || null;
      state.role = user.role || null;
    },
  },
});

export const {
  setOrganizations,
  setActiveOrganization,
  updateOrganizationInList,
  hydrateFromStorage,
} = organizationSlice.actions;

export default organizationSlice.reducer;
